import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bowler-results-summary" }
const _hoisted_2 = { class: "bowler-results-summary-data" }

import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import ValueWithLabel from '@/components/common/ValueWithLabel.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerResultsSummary',
  setup(__props) {

const bowler = useBowlerStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ValueWithLabel, {
        label: _ctx.$t('bowler-scores.current-average'),
        value: _unref(formatFloat)(_unref(bowler).currentAverage, 2)
      }, null, 8, ["label", "value"]),
      _createVNode(ValueWithLabel, {
        label: _ctx.$t('bowler-scores.previous-average'),
        value: _unref(formatFloat)(_unref(bowler).previousAverage, 2)
      }, null, 8, ["label", "value"]),
      _createVNode(ValueWithLabel, {
        label: _ctx.$t('bowler-scores.cut-score-games'),
        value: _unref(formatFloat)(_unref(bowler).cutScoreGames, 0)
      }, null, 8, ["label", "value"]),
      _createVNode(ValueWithLabel, {
        label: _ctx.$t('bowler-scores.season-games'),
        value: _unref(formatFloat)(_unref(bowler).seasonGames, 0)
      }, null, 8, ["label", "value"]),
      _createVNode(ValueWithLabel, {
        label: _ctx.$t('bowler-scores.class'),
        value: _unref(formatValue)(_unref(bowler).currentClass)
      }, null, 8, ["label", "value"])
    ]),
    _createVNode(RouterLinkButton, { to: { path: '/results' } }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('nav.results')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})